import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import { GET_NCA_PARENTS_PATH, GetNcaParentsErrorDto, GetNcaParentsSuccessDto } from '@/api/rest/resources/types/nca';
import { assertIsDefined } from '@/utils/assert';

import { useOrganizationId } from './useOrganizationId';

type SuccessDto = GetNcaParentsSuccessDto;
type ErrorDto = GetNcaParentsErrorDto;

export const useNCAParents = (organizationIdArg?: string) => {
  const orgId = useOrganizationId();
  const organizationId = organizationIdArg ?? orgId;

  assertIsDefined(organizationId, 'organizationId');

  const queryParams = { organization_id: organizationId };

  const queryFn = () => {
    return getRequest<SuccessDto>(GET_NCA_PARENTS_PATH, undefined, queryParams);
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: ['nca', 'parents', queryParams],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
